import { type FC } from 'react';

import { useLoadRecentlyUsedTemplates } from 'src/services/templates/useLoadRecentlyUsedTemplates';
// @ts-expect-error - useCurrentCustomerId is not typed yet
import { useCurrentCustomerId } from 'src/store/customer';

import { useLoadRecentlyUsedContentTypes } from './services/useLoadRecentlyUsedContentTypes';
import { NewProjectPromptWidget, type NewProjectPromptWidgetProps } from './NewProjectPromptWidget';
import { MainStoreContainer } from './store';

export const Container: FC<NewProjectPromptWidgetProps> = (props) => {
  const currentCustomerId = useCurrentCustomerId();

  useLoadRecentlyUsedContentTypes();
  useLoadRecentlyUsedTemplates();

  return (
    <MainStoreContainer currentCustomerId={currentCustomerId}>
      <NewProjectPromptWidget {...props} />
    </MainStoreContainer>
  );
};
